<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">{{ date.format('YYYY-MM-DD') }} {{ room.name }} の予約時間を選択</div>
      <div class="card-body">
        <ul>
          <li>
            <!-- 1回あたり{{ reserveMinutesList.join("分または") }}分のご利用となります。-->
            1回あたり35分〜のご利用となります (レッスンにより異なります)
          </li>

          <!-- ルームごとの1日あたりの利用回数の制限 -->
          <!--
          <li v-if="reservableTimesPerDayRoom">
            1日に{{ reservableTimesPerDayRoom }}回までのご利用となります。
          </li>
          -->

          <!-- ルームごとの予約件数の制限 -->
          <!--
          <li v-if="reservableTimesPerRoom === 1">
            同時に複数の予約を行うことはできません。
          </li>
          <li v-else-if="reservableTimesPerRoom > 1">
            同時に{{ reservableTimesPerRoom }}件まで予約できます。
          </li>
          -->
        </ul>

        <div class="mt-3">
          <ul v-if="programSchedules !== null && programSchedules.length" class="list-group">
            <li class="list-group-item text-center bg-dark text-white">&nbsp;</li>

            <li v-for="programSchedule in programSchedules" class="list-group-item text-center">
              <div class="lead font-weight-bold  text-nowrap">
                <div class="lead font-weight-bold  text-nowrap">
                  {{ momentFromHour(programSchedule["start_time"], date).format('HH:mm') }}
                  -
                  {{ momentFromHour(programSchedule["end_time"], date).format('HH:mm') }}

                  <template v-if="!momentFromHour(programSchedule['start_time'], date).isBetween(reservableDatetimeNear, reservableDatetimeFar)">
                    <a class="btn btn-sm btn-dark mb-1 disabled">不可</a>
                  </template>
                  <template v-else-if="isReservable(programSchedule['start_time'], programSchedule['end_time'])">
                    <a @click.prevent="reserveSet(
                                            programSchedule.program,
                                            momentFromHour(programSchedule['start_time'], date),
                                            momentFromHour(programSchedule['end_time'], date)
                                        )" class="btn btn-sm btn-success mb-1 text-white">予約</a>
                  </template>
                  <template v-else-if="reservablePeriods.length">
                    <a class="btn btn-sm btn-danger mt-1 disabled">満員</a>
                  </template>
                </div>
              </div>

              <div class="lead text-nowrap col-auto">
                {{ programSchedule.name }}
              </div>

              <div class="text-nowrap col-auto">
                担当：{{ programSchedule.staff_name }}
              </div>
            </li>
          </ul>
          <ul v-else-if="programSchedules !== null && !programSchedules.length" class="list-group">
            <li class="list-group-item text-center bg-dark text-white">&nbsp;</li>

            <li class="list-group-item text-center">予約できるプログラムはありません。</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      member: {},
      roomId: parseInt(this.$route.params.roomId),
      date: this.moment(this.$route.params.date),
      programId: null,
      reserveMinutesList: [],
      reservableTimesPerDayRoom: this.$config['reservable_times_per_day_room'][this.$route.params.roomId],
      reservableTimesPerRoom: this.$config["reservable_times_per_room"][this.$route.params.roomId],
      room: {
        'programs': []
      },
      programSchedules: null,
      reservablePeriods: [],
      // 予約可能な日時範囲
      reservableDatetimeNear: undefined,
      reservableDatetimeFar: undefined,
    }
  },
  async created() {
    this.$store.commit("loading/setLoading", true);

    // 戻りリンク先を設定
    this.$store.commit("backButton/setTo", "/member");

    // ルーム情報を取得
    await axios.get('/member/api/rooms/' + this.roomId)
        .then(response => {
          this.room = response.data.room;
          this.programId = this.room['programs'][0]['id'];
        })
        .catch(error => this.$store.state.error.code = error.response.status);

    await Promise.all([
      // メンバー情報を取得
      this.getMember(),
      // プログラムスケジュール情報を取得
      this.getProgramSchedules(),
      // 予約可能・不可能な時間帯のリストを取得
      this.getReservablePeriods(),
    ]);

    // 予約可能な分数のリストを生成
    for (const programSchedule of this.programSchedules) {
      // 開始時間と終了時間の差を計算
      const start = this.momentFromHour(programSchedule.start_time);
      const end = this.momentFromHour(programSchedule.end_time);
      this.reserveMinutesList.push(end.diff(start, 'minutes'));

      // 重複を削除して数値ソート
      this.reserveMinutesList = Array.from(new Set(this.reserveMinutesList)).sort(function (a, b) {
        return a - b;
      });
    }

    this.$store.commit("loading/setLoading", false);
  },
  methods: {
    // メンバー情報を取得
    async getMember() {
      await axios.get('/member/api/profile/')
          .then(response => this.member = response.data.member)
          .catch(error => this.$store.state.error.code = error.response.status);

      // ユーザごとの予約可能な日時範囲を取得
      this.reservableDatetimeNear = this.moment(this.member["plan"]["reservable_datetime_between"]["near_datetime"]);
      this.reservableDatetimeFar = this.moment(this.member["plan"]["reservable_datetime_between"]["far_datetime"]);
    },
    // プログラムスケジュール情報を取得
    async getProgramSchedules() {
      await axios.get('/member/api/program_schedules', {
        params: {
          'room_id': this.roomId,
          'date': this.date.format('YYYY-MM-DD'),
        }
      })
          .then(response => {
            this.programSchedules = response.data.program_schedules;
          })
          .catch(error => this.$store.state.error.code = error.response.status);
    },
    // 予約可能・不可能な時間帯のリストを取得
    async getReservablePeriods() {
      await axios.get('/member/api/reservable_periods', {
        params: {
          'program_id': this.room.programs[0].id,
          'date': this.date.format('YYYY-MM-DD'),
        }
      })
          .then(response => {
            this.reservablePeriods = response.data.reservable_periods;

          })
          .catch(error => this.$store.state.error.code = error.response.status);
    },

    // 予約可能かどうかチェックする
    isReservable(start, end) {
      let reservable = false;
      start = this.momentFromHour(start, this.date);
      end = this.momentFromHour(end, this.date);

      for (let reservablePeriod of this.reservablePeriods) {
        let reservableStart = this.momentFromHour(reservablePeriod.start_time, this.date);
        let reservableEnd = this.momentFromHour(reservablePeriod.end_time, this.date);

        // 開始時間と終了時間が予約可能な時間帯の範囲内かどうか
        if (
            start.isBetween(reservableStart, reservableEnd, null, '[]')
            && end.isBetween(reservableStart, reservableEnd, null, '[]')
        ) {
          reservable = true;
          break;
        }
      }

      return reservable;
    },

    // 予約の実行
    async reserveSet(program, start, end) {
      let msg = "以下の内容で予約を行います。よろしいですか?<br>";
      msg += this.room['name'] + "<br>";
      // msg += program['name'] + "<br>";
      msg += this.date.format('M月D日') + " ";
      msg += start.format('HH:mm') + '-' + end.format('HH:mm') + " ";
      msg += "(" + end.diff(start, 'minutes') + "分)";

      this.$dialog.confirm(msg).then(async () => {
        this.$store.commit("loading/setLoading", true);

        // 予約情報を保存
        await axios.post('/member/api/reservations', {
          program_id: program.id,
          start_datetime: start.format('YYYY-MM-DD HH:mm:ss'),
          end_datetime: end.format('YYYY-MM-DD HH:mm:ss'),
        })
            .then(response => {
              this.$toasted.show('予約しました');

              // 広告コンバージョンタグ実行用外部ページ呼び出しiframeを生成
              this.$store.commit("iframe/setUrl",
                  this.$config.app_url + "/ad/d-ap-cv.html"
                  + "?args=" + this.member.id
                  + "-" + response?.["data"]?.["reservation"]?.["id"]
              );
            })
            .catch((error) => {
                  const {data, status, statusText} = error.response;
                  if (status === 422) {
                    for (let msg of Object.values(data.errors).flat()) {
                      this.$toasted.show(msg, {type: 'error'});
                    }
                  } else {
                    this.$store.state.error.code = error.response.status;
                  }
                }
            );

        // 予約可能・不可能な時間帯のリストを再取得
        this.getReservablePeriods();

        this.$store.commit("loading/setLoading", false);
      });
    },
  }
};
</script>

